

import { Component } from "@/utils/types/componentTypes";
import { TableCell, TableRow } from "@/components/ui/table";
import { Pencil, Trash, FileText, Copy } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { useToast } from "@/hooks/use-toast";

interface ComponentsTableRowProps {
  component: Component;
  onEdit: (component: Component) => void;
  onDelete: (component: Component) => void;
}

export const ComponentsTableRow = ({
  component,
  onEdit,
  onDelete,
}: ComponentsTableRowProps) => {
  const navigate = useNavigate();
  const { toast } = useToast();

  const handleCopyId = async () => {
    try {
      await navigator.clipboard.writeText(component.id);
      toast({
        title: "ID copiado",
        description: "O ID do componente foi copiado para a área de transferência.",
      });
    } catch (error) {
      toast({
        title: "Erro ao copiar",
        description: "Não foi possível copiar o ID.",
        variant: "destructive",
      });
    }
  };

  // Get the component type display text (Group - Type or just Type)
  const getComponentTypeDisplay = () => {
    if (component.component_types?.group_name) {
      return `${component.component_types.group_name} - ${component.component_types.name}`;
    }
    return component.component_types?.name || component.component_type_name || "N/A";
  };

  return (
    <TableRow className="hover:bg-muted/20">
      <TableCell className="font-medium">{component.name}</TableCell>
      <TableCell className="text-muted-foreground">{getComponentTypeDisplay()}</TableCell>
      <TableCell className="text-muted-foreground">
        {component.code_changes_7days !== null && component.code_changes_7days !== undefined 
          ? component.code_changes_7days 
          : "-"}
      </TableCell>
      <TableCell className="text-muted-foreground">
        {component.deploys_7days !== null && component.deploys_7days !== undefined 
          ? component.deploys_7days 
          : "-"}
      </TableCell>
      <TableCell className="text-right">
        <div className="flex items-center justify-end gap-1">
          <Button
            variant="ghost"
            size="icon"
            className="h-8 w-8"
            onClick={handleCopyId}
            title="Copiar ID"
          >
            <Copy className="h-4 w-4" />
          </Button>
          <Button
            variant="ghost"
            size="icon"
            className="h-8 w-8"
            onClick={() => navigate(`/componente-detalhes/${component.id}`)}
            title="Detalhes"
          >
            <FileText className="h-4 w-4" />
          </Button>
          <Button
            variant="ghost"
            size="icon"
            className="h-8 w-8"
            onClick={() => onEdit(component)}
            title="Editar"
          >
            <Pencil className="h-4 w-4" />
          </Button>
          <Button
            variant="ghost"
            size="icon"
            className="h-8 w-8 text-destructive hover:text-destructive"
            onClick={() => onDelete(component)}
            title="Excluir"
          >
            <Trash className="h-4 w-4" />
          </Button>
        </div>
      </TableCell>
    </TableRow>
  );
};

